/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

// core components
import { useRecoilValue } from "recoil";
import { websiteDataState } from "helpers/recoil";

function SectionContact() {
    const websiteData = useRecoilValue(websiteDataState)

    const [isMobile, setIsMobile] = useState(false)

    //choose the screen size
    const handleResize = () => {
        if (window.innerWidth < 992) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }

    const MyMapComponent = withScriptjs(withGoogleMap((props) =>
        <GoogleMap
            defaultZoom={16}
            defaultCenter={{ lat: 50.9045068, lng: 3.5224238 }}
            defaultOptions={{
                disableDefaultUI: false,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true
            }}
        >
            {props.isMarkerShown && <Marker position={{ lat: 50.9042602, lng: 3.5226789 }} />}
        </GoogleMap>
    ))

    // create an event listener
    useEffect(() => {
        window.addEventListener("resize", handleResize)
    })

    return (
        <>
            <div className="section" style={{ marginBottom: 0, paddingBottom: 0, paddingTop: "80px" }}>
                <Container>
                    <Row>
                        <Col className="ms-auto me-auto text-center" md="10" lg="8">
                            <h2 className="title" style={{ 
                                fontSize: "36px", 
                                fontWeight: "700",
                                color: "#2d3748",
                                marginBottom: "48px",
                                letterSpacing: "-0.5px",
                                lineHeight: "1.2"
                            }}>Contact</h2>
                        </Col>
                    </Row>
                </Container>
                <Container style={{ marginTop: "40px", marginBottom: "80px" }}>
                    <Row style={{ alignItems: "stretch" }}>
                        <Col sm="12" md="12" lg="6" style={{ marginBottom: isMobile ? "30px" : "0" }}>
                            <div style={{ 
                                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
                                overflow: "hidden",
                                height: "100%",
                                minHeight: "500px",
                                borderRadius: "16px"
                            }}>
                                <MyMapComponent
                                    isMarkerShown
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDtNcC0cwtEVJS5NeWpe362KJAYS4ZL45Q&v=beta&libraries=geometry,drawing,places"
                                    loadingElement={<div style={{ height: `0%` }} />}
                                    containerElement={<div style={{ height: `100%`, minHeight: "500px" }} />}
                                    mapElement={<div style={{ height: `100%` }} />}
                                />
                            </div>
                        </Col>
                        <Col sm="12" md="12" lg="6" style={{ 
                            textAlign: isMobile ? "center" : "left",
                            padding: "40px",
                            background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
                            borderRadius: "16px",
                            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)"
                        }} >

                            <p style={{ 
                                fontSize: "16px", 
                                fontWeight: "700",
                                letterSpacing: "-0.3px",
                                marginBottom: "16px",
                                lineHeight: "1.4",
                                color: "#2d3748"
                            }}>
                                NOTEBAERT <span style={{ color: "#69be50", margin: "0px 6px" }}>|</span> STANDAERT<br />
                                <span style={{ 
                                    background: "linear-gradient(135deg, #69be50 0%, #5aa542 100%)",
                                    color: "#FFFFFF", 
                                    padding: "5px 10px", 
                                    marginTop: "8px", 
                                    fontWeight: "600",
                                    fontSize: "12px",
                                    borderRadius: "6px",
                                    display: "inline-block",
                                    boxShadow: "0 4px 15px rgba(105, 190, 80, 0.3)"
                                }}>GROEPSPRAKTIJK KINESITHERAPIE</span>
                            </p>

                            <p style={{ 
                                fontSize: "16px", 
                                color: "#4a5568",
                                marginBottom: "25px",
                                lineHeight: "1.6"
                            }}>{websiteData?.snippetsDictionary?.['global-address']?.text || ""}</p>

                            <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                                <div style={{ display: "flex", gap: "12px", marginBottom: "16px", flexWrap: "wrap" }}>
                                    {(websiteData?.snippetsDictionary?.['global-phoneNumber']?.text || "").split("-").map((phone, index) => {
                                      const cleanPhone = phone.trim();
                                      const telLink = cleanPhone.replace(/[^\d]/g, "");
                                      return (
                                        <a key={index} href={`tel:${telLink}`} style={{ 
                                            background: "linear-gradient(135deg, #00adee 0%, #0096cc 100%)",
                                            color: "#FFFFFF", 
                                            padding: "10px 20px", 
                                            fontWeight: "600",
                                            fontSize: "16px",
                                            borderRadius: "6px",
                                            display: "inline-block",
                                            boxShadow: "0 4px 15px rgba(0, 173, 238, 0.3)",
                                            textDecoration: "none",
                                            transition: "all 0.3s ease"
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                                        >{cleanPhone}</a>
                                      );
                                    })}
                                </div>
                                <p style={{ fontSize: "16px", lineHeight: "1.8", margin: 0 }}>
                                    <span style={{ color: "#4a5568", fontSize: "16px" }}>{websiteData?.snippetsDictionary?.['global-email']?.text || ""}</span>
                                </p>
                            </div>
                            <p style={{ 
                                fontSize: "15px", 
                                color: "#4a5568",
                                marginBottom: "15px",
                                lineHeight: "1.8"
                            }}>
                                <strong style={{ color: "#2d3748", fontWeight: "600" }}>Riziv Erkenningen:</strong>
                                <br />
                                {websiteData?.people?.map(p => p.riziv).join(", ")}
                            </p>
                            <p style={{ 
                                fontSize: "15px", 
                                color: "#4a5568",
                                lineHeight: "1.8"
                            }}>
                                <strong style={{ color: "#2d3748", fontWeight: "600" }}>Ondernemingsnummer:</strong>
                                <br />
                                {websiteData?.snippetsDictionary?.['global-kbo']?.text || ""}
                            </p>
                            <p>
                                <strong>Bankrekening:</strong>
                                <br />
                                {websiteData?.snippetsDictionary?.['global-bank']?.text || ""}
                            </p>

                            <hr />

                            <p>
                                <strong>Parkeergelegenheid:</strong><br />{websiteData?.snippetsDictionary?.['section-body-contact']?.text || ""}</p>


                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default SectionContact;
